export const ASSET_CATEGORIES = ["Gym Equipment", "Furniture", "IT", "Cafe", "Other"];

export const ASSET_STATUSES = [
  ["active", "Active"],
  ["draft", "Draft"],
  ["inactive", "Inactive"],
  ["under_repair", "Under repair"],
  ["damaged", "Damaged"],
  ["missing", "Missing"],
  ["disposed", "Disposed"],
];

export const ASSET_CONDITIONS = ["excellent", "good", "fair", "poor", "damaged"];

export const money = (value) =>
  "Rs " + Number(value || 0).toLocaleString("en-PK");

export const hoursLabel = (minutes) => {
  const total = Math.max(0, Number(minutes) || 0);
  const hours = Math.floor(total / 60);
  const rest = total % 60;
  if (hours === 0) return `${rest}m`;
  return `${hours}h ${rest}m`;
};

export const statusLabel = (status) =>
  (ASSET_STATUSES.find(([value]) => value === status) || [status, status])[1];

export const JOB_TYPES = [
  ["maintenance", "Preventive maintenance"],
  ["repair", "Repair"],
  ["downtime", "Downtime"],
  ["inspection", "Inspection"],
];

export const jobTypeLabel = (type) =>
  (JOB_TYPES.find(([value]) => value === type) || [type, type])[1];

export const conditionLabel = (condition) => {
  const text = String(condition || "").replace(/_/g, " ");
  return text ? text.charAt(0).toUpperCase() + text.slice(1) : "—";
};

export const formatDate = (value) => {
  if (!value) return "—";
  const text = String(value).replace(" ", "T");
  const date = new Date(text.length === 10 ? text + "T00:00:00" : text);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
};
